import * as cookies from 'cookies-next';
import { d as COOKIE_FIRST_VISIT_NAME, m as COOKIE_LANG_PREF, n as COOKIE_CURRENCY_PREF, b as COOKIE_CURRENCY_NAME } from '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-5CMab_Gs.js';
import { isBot } from './isBot.js';

const getCookies = (ctx = {}) => cookies.getCookies(ctx);
const getCookie = (name, ctx = {}) => cookies.getCookie(name, ctx);
const setCookie = (name, value, ctx = {}) => {
    cookies.setCookie(name, value, ctx);
};
const removeCookie = (name, ctx = {}) => {
    cookies.deleteCookie(name, ctx);
    try {
        // Remove from CookieRestorer localStorage, preventing cookie restoration in Safari
        if (typeof window !== 'undefined') {
            const storageKey = 'cookieRes';
            const storedCookies = JSON.parse(localStorage.getItem(storageKey) || '[]');
            const updatedCookies = storedCookies.filter((cookie) => cookie.key !== name);
            localStorage.setItem(storageKey, JSON.stringify(updatedCookies));
        }
    }
    catch (e) {
        console.error('Error removing cookie', name, e);
    }
};
// A custom method for setCookie from browser
// This can be used instead of the "cookies.setCookie" method
// because "cookies.setCookie" method uses a stringify method for the value processing
// which can cause to some characters replacement
// which may be not an expected behavior
const setClientCookie = (key, val, expires, path) => {
    document.cookie = `${key}=${val}; expires=${expires.toUTCString()}; path=${path}`;
};
/**
 * OnetrustActiveGroups:
 * 1:1, Strictly Necessary Cookies
 * 3:0, Functional
 * 4:1, Advertising
 * 6:1 Analytics
 */
const setFirstVisitCookie = (userAgent, consent) => {
    if (!isBot(userAgent)) {
        const oneMonthFromNow = new Date();
        oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
        const options = (consent === null || consent === void 0 ? void 0 : consent.preferences) ? { expires: oneMonthFromNow } : {};
        setCookie(COOKIE_FIRST_VISIT_NAME, 'no', options);
    }
    else {
        removeCookie(COOKIE_FIRST_VISIT_NAME);
    }
};
const setPreferredLangCookie = (userAgent, currency, lang, consent, ctx = {}) => {
    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
    if (!isBot(userAgent)) {
        // Set the "preferredLang" and "preferredCurrency" cookies
        const options = (consent === null || consent === void 0 ? void 0 : consent.preferences) ? { ...ctx, expires: oneMonthFromNow } : {};
        setCookie(COOKIE_LANG_PREF, lang, options);
        setCookie(COOKIE_CURRENCY_PREF, currency, options);
        if (!getCookie(COOKIE_CURRENCY_NAME, ctx)) {
            setCookie(COOKIE_CURRENCY_NAME, currency, options);
        }
    }
    else {
        // Remove the "preferredLang" and "preferredCurrency" cookies
        removeCookie(COOKIE_LANG_PREF, ctx);
        removeCookie(COOKIE_CURRENCY_PREF, ctx);
    }
};
const getFirstNonNullCookie = (cookieNames, ctx = {}) => {
    const cookieValue = cookieNames
        .map(name => { var _a; return (_a = getCookie(name, ctx)) === null || _a === void 0 ? void 0 : _a.toString(); })
        .find(value => value);
    return cookieValue || '';
};
const getOneMonthFromNow = () => {
    const now = new Date();
    now.setMonth(now.getMonth() + 1);
    return now;
};

export { getCookie, getCookies, getFirstNonNullCookie, getOneMonthFromNow, removeCookie, setClientCookie, setCookie, setFirstVisitCookie, setPreferredLangCookie };
//# sourceMappingURL=cookies.js.map
